var render, staticRenderFns
import script from "./tTableColumn.vue?vue&type=script&lang=js"
export * from "./tTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d62d74",
  null
  
)

export default component.exports